import { Component, OnInit } from '@angular/core';
import {NotificationsService} from "../../common/service/notifications.service";
import {CinchDataService} from "../../common/service/cinch-data.service";
import {UtilitiesService} from "../../common/service/utilities.service";
import {ApiContractDataModel, ApiPhone} from "../../common/model/cchsApiContractData.model";
import {ProfileData} from "../../common/model/cinchAppViewData.model";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  contract;
  profileDataIsSet:boolean = false;
  profileData: ProfileData;

  constructor(private util:UtilitiesService,
              private cinchData: CinchDataService,
              private notificationMsg: NotificationsService) { }

  ngOnInit() {

    this.cinchData.contractData$.subscribe(contract => {
        if ( (contract) && (contract != {}) && (contract.baseContract) ) {
          this.contract = contract;
          this.profileData = this.cinchData.getProfileViewOnFormat(contract);
          this.profileDataIsSet = true;

          console.log("ProfileComponent out:", {
              contract: contract,
              profileData: this.profileData
          });
        }
    } , e => console.log());

    this.cinchData.notification$.subscribe(notification => console.log("DashboardComponent notification$", notification) , e => console.log());
  }

  goto( route ){ this.util.goTo(route); }


}
